import { getLabel } from '../../../lib/labels.js';
import { matchPermissionsToRoute } from 'lib/constants/permissions.js';

const validateLink = (params, route) => (isNaN(parseInt((params || {}).serviceProviderId)) ? '/dashboard/service-providers' : route);

const getAppHeaderNavLinks = ({ serviceProviderId, tresioUser, folders, defaultPipelineId, params, location, isMobile, allPermissions }) => {
  const inboxFolders = (folders || []).map((folder) => ({
    id: folder.id,
    label: folder.name,
    link: `/${serviceProviderId}/inbox/${folder.id}`,
    eventKey: 'new_message',
    svg: folder.svg,
  }));
  return [
    ...inboxFolders,
    {
      label: 'Pipelines',
      link: `/${serviceProviderId}/pipelines/${defaultPipelineId || ''}`,
      matchLink: `/${serviceProviderId}/pipelines`,
      eventKey: 'pipelines',
      svg: 'Pipelines',
    },
    {
      label: getLabel('todos'),
      link: `/${serviceProviderId}/todos`,
      eventKey: 'todos',
      svg: 'Todos',
    },
    {
      label: 'Activity',
      link: `/${serviceProviderId}/activity/communication-logs`,
      eventKey: 'logs',
      svg: 'CommunicationLogs',
    },
    {
      label: 'Reports',
      link: `/${serviceProviderId}/reports/insights`,
      eventKey: 'reports',
      svg: 'Reports',
    },
  ]
    .map((n) => ({
      ...n,
      link: validateLink(params, n.link),
      active: location.pathname.slice(0, (n.matchLink || n.link).length) === (n.matchLink || n.link),
    }))
    .map((n) => {
      let baseObj = { ...n, disabled: false };
      const permissionData = matchPermissionsToRoute(n.link);
      const isPermitted = tresioUser || (allPermissions || []).find((n) => n === (permissionData || {}).permission);
      if (!isPermitted) {
        baseObj.disabled = true;
      }
      return baseObj;
    })
    .filter((n) => isMobile || n.mobile !== true);
};

export default getAppHeaderNavLinks;
